export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('reveal', {
    mounted(el, binding) {
      const options = binding.value || {}
      const delay = options.delay || 0
      const direction = options.direction || 'up'

      // Set initial state
      el.style.opacity = '0'
      el.style.transition = `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`

      const transforms = {
        up: 'translateY(30px)',
        down: 'translateY(-30px)',
        left: 'translateX(30px)',
        right: 'translateX(-30px)',
      }
      el.style.transform = transforms[direction] || transforms.up

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.style.opacity = '1'
            el.style.transform = 'translate(0, 0)'
            observer.unobserve(el)
          }
        },
        { threshold: 0.1 }
      )

      observer.observe(el)
    },
  })
})
